import { z } from "zod";
import { TraceIdSchema } from "../primitives/ids.js";
export const Tier1WorkflowProofStepStatusSchema = z.enum(["PASS", "FAIL", "SKIP"]);
export const Tier1WorkflowProofStepV1Schema = z
    .object({
    schemaVersion: z.literal("tier1-workflow-proof-step.v1.0"),
    stepId: z.string().min(1),
    status: Tier1WorkflowProofStepStatusSchema,
    evidenceRef: z.string().optional(),
    traceId: TraceIdSchema.optional(),
    detail: z.string().max(500).optional(),
})
    .strict();
export const Tier1WorkflowProofOverallStatusSchema = z.enum(["PASS", "FAIL", "PARTIAL"]);
export const Tier1WorkflowProofResultV1Schema = z
    .object({
    schemaVersion: z.literal("tier1-workflow-proof-result.v1.0"),
    proofRunId: z.string().min(1),
    fixtureVersion: z.string().min(1),
    scenarioId: z.string().min(1),
    overallStatus: Tier1WorkflowProofOverallStatusSchema,
    generatedAt: z.string().datetime(),
    steps: z.array(Tier1WorkflowProofStepV1Schema).min(1),
    automatedProof: z.literal(true),
})
    .strict();
export function computeTier1WorkflowProofOverallStatus(steps) {
    if (steps.every((s) => s.status === "PASS"))
        return "PASS";
    if (steps.every((s) => s.status === "SKIP"))
        return "PARTIAL";
    if (steps.some((s) => s.status === "PASS") && steps.some((s) => s.status === "FAIL")) {
        return "PARTIAL";
    }
    return steps.some((s) => s.status === "FAIL") ? "FAIL" : "PASS";
}
//# sourceMappingURL=tier1-workflow-proof.js.map